import { useEffect, useRef, useState } from "react";
import { getNote } from "@/lib/noteClaim";
import { isAgentCoding, isRecoding } from "@/lib/createClaimsModel";

const busy = (n) => isAgentCoding(n) || isRecoding(n);

// Polls rows revQ is still coding or recoding; swaps in the finished note and flags it "fresh" for a few seconds.
export function useCodingWatch(list, setList, { every = 4000, flashMs = 5000 } = {}) {
  const [fresh, setFresh] = useState(() => new Set());
  const idsRef = useRef([]);
  idsRef.current = (list || []).filter(busy).map((n) => n.id ?? n.note_id).filter(Boolean);
  const watching = idsRef.current.length > 0;

  useEffect(() => {
    if (!watching) return undefined;
    let alive = true;
    const tick = async () => {
      const got = await Promise.all(idsRef.current.map((id) => getNote(id).catch(() => null)));
      if (!alive) return;
      const upd = new Map(got.filter(Boolean).map((n) => [n.id ?? n.note_id, n]));
      if (!upd.size) return;
      setList((all) => all.map((x) => { const u = upd.get(x.id ?? x.note_id); return u ? { ...x, ...u } : x; }));
      const done = [...upd.values()].filter((n) => !busy(n)).map((n) => n.id ?? n.note_id);
      if (done.length) {
        setFresh((s) => new Set([...s, ...done]));
        setTimeout(() => setFresh((s) => { const n = new Set(s); done.forEach((d) => n.delete(d)); return n; }), flashMs);
      }
    };
    const iv = setInterval(tick, every);
    return () => { alive = false; clearInterval(iv); };
  }, [watching, setList, every, flashMs]);

  return fresh;
}
